import { forwardRef } from "react";
import React, { useId } from "react";
function SvgRawLessonSparkFilledIcon({ title, titleId, ...props }, ref) {
  const id = useId();
  const toAppend = "_" + id;
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={32}
      height={32}
      fill="none"
      role="img"
      ref={ref}
      aria-labelledby={titleId}
      {...props}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <path
        fill="#1D1D1D"
        d="M9.963 23.045a1 1 0 0 1 .707.293l.062.07a1 1 0 0 1-.066 1.34l-4.959 4.96a1 1 0 1 1-1.415-1.415l4.964-4.955a1 1 0 0 1 .707-.293Zm6.82 2.166a1.004 1.004 0 0 1 .71.297l-.007-.001a1 1 0 0 1 0 1.415l-2.785 2.784A1.002 1.002 0 0 1 12.993 29a1 1 0 0 1 .293-.707l2.786-2.785a1.002 1.002 0 0 1 .71-.296Zm4-4a1.002 1.002 0 0 1 .71.296l-.007-.001a.999.999 0 0 1 0 1.415l-1.45 1.451a1.002 1.002 0 0 1-1.709-.707c0-.265.105-.52.293-.708l1.453-1.451a1 1 0 0 1 .71-.295ZM6 17.93a1.002 1.002 0 0 1 .708 1.709l-.004-.004-2.996 3.072a1 1 0 0 1-1.415-1.415l3-3.068A1 1 0 0 1 6 17.931Zm6.3 2.674c.265 0 .516.101.703.289a1 1 0 0 1-.312 1.627 1.001 1.001 0 0 1-1.306-1.308.94.94 0 0 1 .209-.316 1 1 0 0 1 .706-.292ZM20.5 2a1.69 1.69 0 0 1 1.554 1.026l1.776 4.208 4.617.366a1.677 1.677 0 0 1 1.488 2.132 1.665 1.665 0 0 1-.53.816l-3.508 2.96 1.07 4.424a1.668 1.668 0 0 1-.636 1.739 1.693 1.693 0 0 1-1.875.086L20.5 17.375l-3.955 2.382a1.689 1.689 0 0 1-2.458-.86 1.666 1.666 0 0 1-.055-.965l1.07-4.424-3.507-2.96a1.676 1.676 0 0 1 .048-2.596c.261-.205.578-.327.91-.351l4.617-.366 1.776-4.208A1.69 1.69 0 0 1 20.5 2.001Zm-1.718 6.572a1 1 0 0 1-.843.609l-4.439.351 3.365 2.842a1.002 1.002 0 0 1 .327 1l-1.035 4.28 3.828-2.304a1.001 1.001 0 0 1 1.032 0l3.827 2.3-1.035-4.276a1 1 0 0 1 .326-1l3.373-2.842-4.442-.351a1.001 1.001 0 0 1-.842-.609L20.5 4.49l-1.718 4.084Zm-8.475 5.12a1.001 1.001 0 0 1 .708 1.707l-.004-.002-1.637 1.642a1 1 0 1 1-1.415-1.415l1.64-1.64a1 1 0 0 1 .708-.293Z"
      />
    </svg>
  );
}
const ForwardRef = forwardRef(SvgRawLessonSparkFilledIcon);
export default ForwardRef;
